import { XCloseIcon, FullscreenIcon, EPResizeMin } from '@rsos/assets/icons';
import Box from '@rsos/base-components/Box';
import Text from '@rsos/base-components/Text';
import { useDispatcherVideoContext } from '../../DispatcherVideoContext/useDispatcherVideoContext';
import { ButtonWrapper, Wrapper, IconContainer } from './Header.styles';

interface Props {
  handleCardClosing: () => void;
}

export const Header = ({ handleCardClosing }: Props) => {
  const { callID, isFullscreen, toggleFullscreen } =
    useDispatcherVideoContext();

  return (
    <Wrapper data-name="live-video-header-wrapper">
      <Box justify="space-between" horizontal>
        <Text color="white" size="large">
          Video Call
        </Text>
        <ButtonWrapper>
          <IconContainer title="Maximize" onClick={toggleFullscreen}>
            {isFullscreen ? <EPResizeMin /> : <FullscreenIcon />}
          </IconContainer>
          <IconContainer title="Close" onClick={handleCardClosing}>
            <XCloseIcon />
          </IconContainer>
        </ButtonWrapper>
      </Box>
      <Text color="white" size="xsmall" fontWeight="bold" marginTop={1}>
        {callID}
      </Text>
    </Wrapper>
  );
};
